import api from "../../service/api"
import routes from "../../service/apiRoutes"

export const getReport = (reportId) => api.get(routes.report, { params: { report_id: reportId }, noauth: true })
export const getReportFiles = (reportId) => api.get(`${routes.report}files`, { params: { report_id: reportId }, noauth: true })
export const buildFileReport = (reportId) => api.put(`${routes.report}file/create?report_id=${reportId}`, {}, {noauth: true})

